
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tweets",
      function () {
        return require("private-next-pages/tweets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tweets"])
      });
    }
  